const helpSubtle = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><circle cx="8" cy="8" r="7.25" stroke-width="1.5"/><path stroke-width="0" d="M9.42 8.37C9 8.64 9 8.73 9 8.92v.92H7.13v-.92c0-.887.494-1.7 1.28-2.11.46-.28.55-.37.55-.65a.86.86 0 0 0-.91-.91 1 1 0 0 0-.83.45l-.46.83-1.56-.92.46-.82a2.74 2.74 0 0 1 2.39-1.38 2.7 2.7 0 0 1 2.75 2.75 2.51 2.51 0 0 1-1.38 2.21m-1.37 4.22a.92.92 0 1 1 0-1.84.92.92 0 0 1 0 1.84"/></svg>',
};

export { helpSubtle as default };
